// @flow

import { StaticContextRoute } from '@atlassian/mpac-ui';
import React, { useEffect } from 'react';

export type RedirectExternalProps = {|
  url: string,
  statusCode?: 301 | 302,
|};

/**
 * Declaratively redirect to a non-SPA route. Works by setting the `window.location.href` when
 * running in the browser and by setting static context during SSR.
 *
 * Side-effect only - renders nothing to the DOM.
 */
const RedirectExternal = (props: RedirectExternalProps) => {
  const { statusCode = 302, url } = props;

  useEffect(() => {
    // effects only run on the browser
    window.location.href = url;
  }, []);

  if (__REACT_SSR__) {
    // during SSR we want to set the static context by rendering the route
    // without any actual content
    return <StaticContextRoute statusCode={statusCode} url={url} render={() => null} />;
  }
  return null;
};

export default RedirectExternal;
